<template>
  <p-people v-if="$hasPermission('users.read')" />
  <p-not-found v-else />
</template>

<script>
import NotFound from './../components/NotFound.vue';
import People from './../components/users/People.vue';

export default {
  components: {
    'p-people': People,
    'p-not-found': NotFound
  }
};
</script>
